import React, { PureComponent } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreators } from "./redux/actions";

class PrivateRoute extends PureComponent {
  render() {
    const { component: AppComponent, privilege, app } = this.props;

    if (app.auth === null) {
      const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <Spin indicator={antIcon} />
        </div>
      );
    }

    return (
      <Route
        render={() => {
          if (app.auth) {
            if (
              privilege === 'ALL' || privilege.indexOf('ALL') >= 0
              || (app.admin.admin_id && privilege === app.admin.role.toUpperCase())
              || (app.admin.admin_id && privilege.indexOf(app.admin.role.toUpperCase()) >= 0)
            ) {
              return <AppComponent />;
            }
          }
          return <Redirect to="/admin/login" />;
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
